<script>
  import http from '../api/http.js';
  import { onMount, onDestroy } from 'svelte';
  import { selectedGroup, currentPage } from '../store.js';
  import { Card, CardBody, CardHeader, CardFooter, Pagination, PaginationLink, PaginationItem, Spinner, Button } from 'sveltestrap';
  import formatDate, { formatJustDate } from '../Helpers/DateTimeFormatter'
  import Search from '../components/Search.svelte';
  import TableColumn from '../components/TableColumn.svelte';
  import Select from 'svelte-select';

  let isLoading = false;
  let searchRefresh = false;
  let inputLength = 0
  let searchTerm = "";
  let software = [];
  let previousPageNumber = 0;
  let pageNumber = 1;
  let totalPageCount = 0;
  let totalComputersCount = 0;
  let computers = [];
  const displayNumbers = [10, 25, 50, 100, 200];
  let displayNumber = displayNumbers[0];
  let sortType = {
    ascending: 'ascending',
    descending: 'descending',
    resting: 'resting'
  }

  let activeColumn = {
    columnValue: 0,
    sortType: sortType.ascending,
  };
  let selectedSoftware = {
      value: '',
      label: ''
  };

  let dropdownOpen = false;

  $: {
      if ($selectedGroup != undefined) {
        loadSoftware();
      }
  }

    $:{
        selectedSoftware;
        loadComputers();
    }
  
  $:{
      pageNumber;
      displayNumber;
      loadComputers(activeColumn.columnValue, activeColumn.sortType);
    }

  $: {
      if (previousPageNumber != pageNumber) {
      previousPageNumber = pageNumber;
    }
  }

  onDestroy(() => {
    clearInterval(interval);
  });

  async function searchComputers(){ 
    searchRefresh = true;    
    let interval = setInterval( async () => {
      if(searchTerm.length != inputLength){
        pageNumber = 1;
        loadComputers(activeColumn.columnValue, activeColumn.sortType);   
      }   
      if(!searchRefresh){
        clearInterval(interval);
      }
      inputLength = searchTerm.length;      
    }, 2000);    
  }

  const interval = setInterval(loadComputers(), 30000); 

  function setPageNumber(number){
    pageNumber = number;    
  }
    
  async function loadSoftware(){
    const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/software/registry/forselect/${$selectedGroup}`);

    if (res.status == 200) {
      software = await res.json();
      selectedSoftware = software[0];       
    }
    else{
      software = [];
      selectedSoftware = {
        value: '',
        label: ''
      };
    }
  }
  
  async function loadComputers(columnValue, sortTypeArg){
    if(selectedSoftware.value != 0){
      if(!isLoading){
        let ascending = sortTypeArg == sortType.ascending ? true : false;
        let url = "";
        if(columnValue == undefined){
            columnValue = 5;
        }
        if(ascending == undefined){
            ascending = true;
        }
        isLoading = true;
        if(searchTerm.length > 0 && searchTerm != ""){
          url = `/deploy/dashboard/computers/byregistry/${$selectedGroup}/${searchTerm}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}/${encodeURIComponent(selectedSoftware.value)}`;
        }
        else{
          url = `/deploy/dashboard/computers/byregistry/${$selectedGroup}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}/${encodeURIComponent(selectedSoftware.value)}`;
        }
        const res = await http.get(window.apiBaseUrl + url);
        if(res.status == 200){
          let uiComputersCollection = await res.json();
          computers = uiComputersCollection.registryEntries;
          totalPageCount = uiComputersCollection.totalPageCount;    
          totalComputersCount = uiComputersCollection.noPaginationComputerCount          
        }
        else{
          computers = [];
        }
        isLoading = false;
      }
    }
  }

  function toggleSort(columnValue, theSortType){
    if(activeColumn.value != columnValue){
      activeColumn.columnValue = columnValue;    
    }
    switch(theSortType){
      case sortType.resting:      
        activeColumn.sortType = sortType.ascending;      
        break;
      case sortType.ascending:
        activeColumn.sortType = sortType.descending;
        break;
      case sortType.descending:
        activeColumn.sortType = sortType.ascending;
        break;
    }
    
    if(activeColumn.sortType != sortType.resting){
      loadComputers(columnValue, activeColumn.sortType);
    }
  }

  async function getSoftwareInventoryCSV() {
    if (selectedSoftware.value) {
      isLoading = true;
      try {
        const url = `/deploy/dashboard/computers/csv/${$selectedGroup}/${encodeURIComponent(selectedSoftware.value)}`;
        const link = document.createElement('a');

        link.href = window.apiBaseUrl + url;
        document.body.appendChild(link);
        
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error downloading CSV:', error);
      } finally {
        isLoading = false;
      }
    }
  }

  async function getAllSoftwareInventoryCSV() {
    if (selectedSoftware.value) {
      isLoading = true;
      try {
        const url = `/deploy/dashboard/computers/csv/${$selectedGroup}`;
        const link = document.createElement('a');

        link.href = window.apiBaseUrl + url;
        document.body.appendChild(link);
        
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error downloading CSV:', error);
      } finally {
        isLoading = false;
      }
    }
  }

</script>

<div class="mt-2">
  <p>This list displays all software throughout your fleet including software that is not managed by the deployment tool.</p>
</div>

<div class="flex mb-2 mt-4">
  <label class="pt-2" for="package-name">Software Name</label>  
  <div>
    <Select id="software-select" isClearable={false} isSearchable={true} bind:selectedValue={selectedSoftware} items={software}></Select> 
  </div>
</div>

<Card>
  <CardHeader>
    <div class="row">
        <div class="col-sm">
            <h6 class="font-weight-bold mt-2 mb-2">Computers with installed software</h6>
        </div>
        {#if isLoading}
          <Spinner color="primary" type="border"></Spinner>
        {/if}
         <div class="col-sm">
            <Search id="computer-search-input" bind:searchTerm placeholder="Search Computers..." on:input={() => searchComputers()}></Search>   
         </div>   
         <div class="col-sm text-right">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" on:click={() => dropdownOpen = !dropdownOpen}>
              Export CSV
            </button>
            {#if dropdownOpen}
              <div class="dropdown-menu dropdown-menu-right show" style="position: absolute;">
                <button class="dropdown-item" disabled={computers.length === 0} on:click={() => { getSoftwareInventoryCSV(); dropdownOpen = false; }}>
                  Export {selectedSoftware.label}
                </button>
                <button class="dropdown-item" on:click={() => { getAllSoftwareInventoryCSV(); dropdownOpen = false; }}>
                  Export All Software
                </button>
              </div>
            {/if}
          </div>
        </div>


    </CardHeader>
  <CardBody>
    {#if computers.length == 0}
      <p>No computers to display.</p>
    {:else}
      <div class="table-responsive">
        <table class="table" width="100%" cellspacing="0">
          <thead>
            <TableColumn on:mousedown={() => toggleSort(0, activeColumn.sortType)} active={activeColumn.columnValue == 0} sortType={activeColumn.sortType}>Vessel</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(1, activeColumn.sortType)} active={activeColumn.columnValue == 1} sortType={activeColumn.sortType}>Computer</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(2, activeColumn.sortType)} active={activeColumn.columnValue == 2} sortType={activeColumn.sortType}>IP Address</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(3, activeColumn.sortType)} active={activeColumn.columnValue == 3} sortType={activeColumn.sortType}>Application</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(4, activeColumn.sortType)} active={activeColumn.columnValue == 4} sortType={activeColumn.sortType}>Version Number</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(6, activeColumn.sortType)} active={activeColumn.columnValue == 6} sortType={activeColumn.sortType}>Install Date</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(5, activeColumn.sortType)} active={activeColumn.columnValue == 5} sortType={activeColumn.sortType}>Publisher</TableColumn>
          </thead>
          <tbody>
            {#each computers as computer}
              <tr>
                <td>{computer.vesselName}</td>
                <td>{computer.hostName}</td>
                <td>{computer.ipAddress}</td>                
                <td>{computer.applicationName}</td>
                <td>{computer.versionNumber === null ? "Data not available" : computer.versionNumber}</td>
                {#if computer.installDate == "Data not available"}
                  <td>Data not available</td>
                {:else}
                  <td>{formatJustDate(computer.installDate)}</td>
                {/if}                
                <td>{computer.publisher === null ? "Data not available" : computer.publisher}</td>
              </tr>            
            {/each}
          </tbody>
        </table>
      </div>
    {/if}    
  </CardBody>
  <CardFooter>
    <div class="pagination bg-light shadow-none ml-0 d-flex">
      {#if computers.length == 0}
        <small class="mt-3 mr-auto">0 - 0 of 0 computers</small>
      {:else}
        {#if searchTerm.length > 0 && searchTerm != ""}
        <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > computers.length ? computers.length:pageNumber * displayNumber)} of {computers.length} computers</small>
        {:else}
          <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalComputersCount ? totalComputersCount:pageNumber * displayNumber)} of {totalComputersCount} computers</small>
        {/if}
      {/if}          
      <div class="mt-2 justify-content-center">
         <Pagination>
            <PaginationItem disabled={pageNumber == 1}>
              <PaginationLink id="pagination-first-page-button" first on:click={() => pageNumber = 1} href="#"/>
            </PaginationItem>

            <PaginationItem  disabled={pageNumber == 1}>
              <PaginationLink id="pagination-previous-page-button" previous on:click={() => setPageNumber(pageNumber - 1)} href="#" />
            </PaginationItem>

            {#if totalPageCount > 5}
              {#each Array(5) as _, count}
                {#if pageNumber > 3 && pageNumber < totalPageCount - 2}
                  <PaginationItem active={pageNumber == count + pageNumber} >
                    <PaginationLink id="pagination-page-{pageNumber + count}-button" on:click={() => setPageNumber(pageNumber + count)} href="#">{pageNumber + count}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber <= 3}
                  <PaginationItem active={pageNumber == count + 1} >
                    <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber >= totalPageCount - 2}
                  <PaginationItem active={pageNumber == totalPageCount - 4 + count} >
                    <PaginationLink id="pagination-page-{totalPageCount - 4 + count}-button" on:click={() => setPageNumber(totalPageCount - 4 + count)} href="#">{totalPageCount - 4 + count}</PaginationLink>
                  </PaginationItem>
                {/if}
              {/each}
            {:else}
              {#each Array(totalPageCount) as _, count}
                <PaginationItem active={pageNumber == count + 1} on:click={() => pageNumber == count + 1}>
                  <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                </PaginationItem>
              {/each}
            {/if}      

            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-next-page-button" next href="#" on:click={() => setPageNumber(pageNumber + 1)} />
            </PaginationItem>
            
            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-last-page-button" last href="#" on:click={() => setPageNumber(totalPageCount)}/>
            </PaginationItem>
          </Pagination>
      </div>
      <div class="mt-3 ml-auto">
        <select class="form-select" id="displayNumberSelect" bind:value={displayNumber}>
          {#each displayNumbers as displayNumber}
            <option value={displayNumber}>{displayNumber}</option>
          {/each}
        </select>
        <label class="ml-1" id="displayNumberLabel" for="displayNumberSelect">Per page</label>     
      </div>  
    </div>
  </CardFooter>
</Card>

<style>

</style>